import React, { useState } from 'react';
import { CheckIcon, FacebookIcon, LinkIcon, LinkedinIcon, MessageCircleIcon } from 'lucide-react';
interface ShareLinksProps {
  title: string;
  layout?: 'row' | 'column';
}

// Share the current article: copy link, WhatsApp, LinkedIn, Facebook.
export function ShareLinks({
  title,
  layout = 'row'
}: ShareLinksProps) {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href.split('#')[0] : '';
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const links = [{
    label: 'Share on WhatsApp',
    href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
    icon: MessageCircleIcon
  }, {
    label: 'Share on LinkedIn',
    href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    icon: LinkedinIcon
  }, {
    label: 'Share on Facebook',
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    icon: FacebookIcon
  }];
  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }
  const buttonClass = 'flex h-10 w-10 items-center justify-center rounded-full bg-mist text-ink transition-colors duration-150 hover:bg-brand hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand';
  return <div className={`flex gap-2 ${layout === 'column' ? 'flex-col' : 'flex-row flex-wrap'}`} data-id="element-96" data-mp="1j010mtfqt7rr">
      <button type="button" onClick={copy} aria-label={copied ? 'Link copied' : 'Copy link'} className={buttonClass} data-id="element-97" data-mp="1dzd986nlqox0">
        {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="19360y77qh1bw" /> : <LinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="1431tt7sptiyc" />}
      </button>
      {links.map(({
      label,
      href,
      icon: Icon
    }) => <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label} className={buttonClass} data-id="element-100" data-mp="33ektevs4pevc">
          <Icon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="2ydx186s5yrzj" />
        </a>)}
      <span className="sr-only" aria-live="polite" data-id="element-102" data-mp="wp9b92ednejc">
        {copied ? 'Link copied to clipboard' : ''}
      </span>
    </div>;
}